import {
  CriticalIllnessProductBackend,
  mapToCommerceCriticalIllness,
} from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceCriticalIllness";
import {
  DeathProductBackend,
  mapToCommerceDeath,
} from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceDeath";
import {
  DisabilityProductBackend,
  mapToCommerceDisability,
} from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceDisability";
import {
  AkaStudentProductBackend,
  mapToCommerceAkaStudent,
} from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/mappers/mapToCommerceAkaStudent";
import {
  AkaChildProductBackend,
  mapToCommerceAkaChild,
} from "Components/Features/CheckPrice/Products/LifeProducts/AkaChild/mappers/mapToCommerceAkaChild";
import {
  AkaHealthWithoutSigningProductBackend,
  mapToCommerceAkaHealth,
} from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/mappers/mapToCommerceAkaHealth";
import {
  ChildProductBackend,
  mapToCommerceChild,
} from "Components/Features/CheckPrice/Products/LifeProducts/Child/mappers/mapToCommerceChild";
import {
  ChildHealthProductBackend,
  mapToCommerceChildHealth,
} from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductPrice/ChildHealth/mapToCommerceChildHealth";
import {
  HealthProductBackend,
  mapToCommerceHealth,
} from "Components/Features/CheckPrice/Products/LifeProducts/Health/mappers/mapToCommerceHealth";
import {
  HealthWithoutSigningProductBackend,
  mapToCommerceHealthWithoutSigning,
} from "Components/Features/CheckPrice/Products/LifeProducts/Health/mappers/mapToCommerceHealthWithoutSigning";
import {
  PregnantAndNewbornProductBackend,
  mapToCommercePregnantAndNewborn,
} from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/mappers/mapToCommercePregnantAndNewborn";
import {
  SopSicknessLeaveProductBackend,
  mapToCommerceSopSicknessLeave,
} from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/mappers/mapToCommerceSopSicknessLeave";
import {
  AccidentProductBackend,
  mapToCommerceAccident,
} from "Components/Features/CheckPrice/Products/RiskProducts/Accident/mappers/mapToCommerceAccident";
import {
  AkaFamilyAccidentProductBackend,
  mapToCommerceAkaFamilyAccident,
} from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/mappers/mapToCommerceAkaFamilyAccident";
import {
  AkaTravelProductBackend,
  mapToCommerceAkaTravel,
} from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel/mappers/mapToCommerceAkaTravel";
import {
  AnimalProductBackend,
  mapToCommerceAnimal,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/mappers/mapToCommerceAnimal";
import {
  AkaHouseContentsProductBackend,
  mapToCommerceAkaHouseContents,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/AkaHouseContents/mappers/mapFromCommerceAkaHouseContents";
import {
  CabinProductBackend,
  mapToCommerceCabin,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/mappers/mapToCommerceCabin";
import {
  CabinContentsProductBackend,
  mapToCommerceCabinContents,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/mappers/mapToCommerceCabinContents";
import {
  HouseProductBackend,
  mapToCommerceHouse,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/mappers/mapToCommerceHouse";
import {
  HouseContentsProductBackend,
  mapToCommerceHouseContents,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HouseContents/mappers/mapToCommerceHouseContents";
import {
  HuseierneHouseContentsProductBackend,
  mapToCommerceHuseierneHouseContents,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/mappers/mapToCommerceHuseierneHouseContents";
import {
  RentalProductBackend,
  mapToCommerceRental,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental/mappers/mapToCommerceRental";
import {
  TravelProductBackend,
  mapToCommerceTravel,
} from "Components/Features/CheckPrice/Products/RiskProducts/Travel/mappers/mapToCommerceTravel";
import { mapToCommerceValuables } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/mappers/mapToCommerceValuables";
import {
  BoatProductBackend,
  mapToCommerceBoat,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/mappers/mapToCommerceBoat";
import {
  CarProductBackend,
  mapToCommerceCar,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/mappers/mapToCommerceCar";
import {
  CaravanProductBackend,
  mapToCommerceCaravan,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/mappers/mapToCommerceCaravan";
import { mapToCommerceElectricScooter } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/ElectricScooter/mappers/mapToCommerceElectricScooter";
import {
  MopedProductBackend,
  mapToCommerceMoped,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Moped/mappers/mapToCommerceMoped";
import {
  MotorcycleProductBackend,
  mapToCommerceMotorcycle,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/mappers/mapToCommerceMotorcycle";
import {
  TractorProductBackend,
  mapToCommerceTractor,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor/mappers/mapToCommerceTractor";
import {
  TrailerProductBackend,
  mapToCommerceTrailer,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Trailer/mappers/mapToCommerceTrailer";
import {
  VeteranAutoProductBackend,
  mapToCommerceVeteranAuto,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/VeteranAuto/mappers/mapToCommerceVeteranAuto";
import { PaymentPeriod } from "Constants/constants";
import { AkaCriticalIllnessProductBackend } from "Store/akaAdvice/mappers/mapToCartProducts/mapToAkaCriticalIllnessProduct";
import { AkaGroupLifeProductBackend } from "Store/akaAdvice/mappers/mapToCartProducts/mapToAkaGroupLifeProduct";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { Partner } from "Store/partners/partnerInterfaces";
import { agreementFromPartnerId } from "Store/partners/partnerUtils";
import { AkaHealthCalculationPrice } from "Store/priceCalculation/priceCalculationInterfaces";
import { AgreementCode } from "Store/userIdentification/agreementCodes";

export const JACKSON_MAGIC_DELETE_KEYWORD = "__DELETE__";

enum CodeOptions {
  ONE = "1",
  TWO = "2",
  THREE = "3",
  FOUR = "4",
  FIVE = "5",
  SIX = "6",
  SEVEN = "7",
  ELEVEN = "11",
  TWELVE = "12",
  THIRTEEN = "13",
  FIFTEEN = "15",
  SEVENTEEN = "17",
  NINETEEN = "19",
  BE = "BE",
}

enum ValueOptions {
  ONE = "1000",
  THREE = "3000",
  FOUR = "4000",
  SIX = "6000",
  EIGHT = "8000",
  TEN = "10000",
  TWELVE = "12000",
  FOURTEEN = "14000",
  SIXTEEN = "16000",
  EIGHTEEN = "18000",
  THRITY = "30000",
  THIRTYTWO = "32000",
  NONE = "Ingen",
}

export function mapFormToProduct(
  partnerId: string,
  type: string,
  data: { [key: string]: any },
): { [key: string]: any } {
  const discountData = data.customerData.discountResponse.f2100;
  let agreementProduct =
    partnerId === Partner.STOREBRAND
      ? discountData.agreementProduct
      : agreementFromPartnerId(partnerId);
  let paymentPeriod =
    discountData.paymentPeriod === "" ? null : discountData.paymentPeriod;
  if (data.type === INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN) {
    agreementProduct = AgreementCode.NORMAL_TARIFF;
    paymentPeriod = PaymentPeriod.SHORT_TERM.toString();
  }

  return {
    cartId: data.cartId ?? data.customerData.newCartResponse.cartId,
    productId: data.productId ?? "", // Backend will generate a new productId
    visible: true,
    ...mapFormToProductProperties(type, data),
    priceSpecifications: {
      price: {
        perMonth: data.priceData.monthlyPrice,
        perMonthPrecise: data.priceData.monthlyPricePrecise,
        perMonthFull: data.priceData.fullMonthlyPrice,
        perMonthFullPrecise: data.priceData.fullMonthlyPricePrecise,
        perYear: data.priceData.yearlyPrice,
        perYearPrecise: data.priceData.yearlyPricePrecise,
        perYearFull: data.priceData.fullYearlyPrice,
        perYearFullPrecise: data.priceData.fullYearlyPricePrecise,
        ...getAkaHealthWithoutSigningPriceSpecifications(data),
      },
      discount: {
        agreementProduct,
        paymentPeriod,
        isNewInsuranceCustomer: discountData.isNewInsuranceCustomer,
      },
      deductible: {
        code: getCorrectCode(data.type, data.priceData),
        value: getCorrectValue(data.type, data.priceData),
      },
    },
  };
}

const getAkaHealthWithoutSigningPriceSpecifications = (data: {
  [key: string]: any;
}): AkaHealthCalculationPrice => {
  if (data.type === INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING) {
    return {
      memberMonthlyPrice: data.priceData.memberMonthlyPrice,
      memberMonthlyPricePrecise: data.priceData.memberMonthlyPricePrecise,
      memberYearlyPrice: data.priceData.memberYearlyPrice,
      memberYearlyPricePrecise: data.priceData.memberYearlyPricePrecise,
      coInsuredMonthlyPrice: data.priceData.coInsuredMonthlyPrice,
      coInsuredMonthlyPricePrecise: data.priceData.coInsuredMonthlyPricePrecise,
      coInsuredYearlyPrice: data.priceData.coInsuredYearlyPrice,
      coInsuredYearlyPricePrecise: data.priceData.coInsuredYearlyPricePrecise,
    };
  }

  return {};
};

const getCorrectCode = (
  type: INSURANCE_NAME_VALUE,
  priceData: Record<string, any>,
): string => {
  const { code, value } = priceData;

  switch (type) {
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
    case INSURANCE_NAME_VALUE.DEATH:
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
    case INSURANCE_NAME_VALUE.CHILD:
    case INSURANCE_NAME_VALUE.NEW_CHILD:
    case INSURANCE_NAME_VALUE.TRAVEL:
      return "BE";
    case INSURANCE_NAME_VALUE.MOPED:
    case INSURANCE_NAME_VALUE.TRACTOR:
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return ValueOptions.FOUR;
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return Object.values(ValueOptions).includes(value as any)
        ? value
        : ValueOptions.ONE;
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      if (value === ValueOptions.NONE) {
        return ValueOptions.SIX;
      }
      return Object.values(ValueOptions).includes(value as any)
        ? value
        : ValueOptions.SIX;
    case INSURANCE_NAME_VALUE.ACCIDENT:
    case INSURANCE_NAME_VALUE.CAR:
    case INSURANCE_NAME_VALUE.BOAT:
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return value;
    case INSURANCE_NAME_VALUE.ANIMAL:
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return code;
    default:
      return Object.values(ValueOptions).includes(value as any) ? value : "BE";
  }
};

const getCorrectValue = (
  type: INSURANCE_NAME_VALUE,
  priceData: Record<string, any>,
): string => {
  const { code, value } = priceData;
  const options = Object.values(CodeOptions);

  if (
    !options.includes(code) &&
    type !== INSURANCE_NAME_VALUE.ANIMAL &&
    type !== INSURANCE_NAME_VALUE.CHILD_HEALTH
  ) {
    return "N";
  }

  if (
    type === INSURANCE_NAME_VALUE.AKA_TRAVEL ||
    type === INSURANCE_NAME_VALUE.TRAVEL ||
    type === INSURANCE_NAME_VALUE.ANIMAL ||
    type === INSURANCE_NAME_VALUE.CHILD_HEALTH
  ) {
    return value;
  }

  return code;
};

export type ProductBackend =
  | AkaFamilyAccidentProductBackend
  | AkaGroupLifeProductBackend
  | AkaChildProductBackend
  | AkaCriticalIllnessProductBackend
  | AkaHealthWithoutSigningProductBackend
  | AkaHouseContentsProductBackend
  | AkaTravelProductBackend
  | AkaStudentProductBackend
  | AccidentProductBackend
  | AnimalProductBackend
  | BoatProductBackend
  | CabinContentsProductBackend
  | CabinProductBackend
  | CaravanProductBackend
  | CarProductBackend
  | ChildProductBackend
  | ChildHealthProductBackend
  | CriticalIllnessProductBackend
  | DeathProductBackend
  | DisabilityProductBackend
  | HealthProductBackend
  | HealthWithoutSigningProductBackend
  | HouseContentsProductBackend
  | HouseProductBackend
  | HuseierneHouseContentsProductBackend
  | MopedProductBackend
  | MotorcycleProductBackend
  | PregnantAndNewbornProductBackend
  | RentalProductBackend
  | SopSicknessLeaveProductBackend
  | TractorProductBackend
  | TrailerProductBackend
  | TravelProductBackend
  | VeteranAutoProductBackend;

function mapFormToProductProperties(
  type: string,
  data: { [key: string]: any },
): ProductBackend | undefined {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (type) {
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return mapToCommerceAccident(data);
    case INSURANCE_NAME_VALUE.AKA_CHILD:
      return mapToCommerceAkaChild(data);
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
      return mapToCommerceAkaFamilyAccident(data);
    case INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING:
      return mapToCommerceAkaHealth(data);
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return mapToCommerceAkaHouseContents(data);
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return mapToCommerceAkaTravel(data);
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return mapToCommerceAkaStudent(data);
    case INSURANCE_NAME_VALUE.ANIMAL:
      return mapToCommerceAnimal(data);
    case INSURANCE_NAME_VALUE.BOAT:
      return mapToCommerceBoat(data);
    case INSURANCE_NAME_VALUE.CABIN:
      return mapToCommerceCabin(data);
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return mapToCommerceCabinContents(data);
    case INSURANCE_NAME_VALUE.CAR:
      return mapToCommerceCar(data);
    case INSURANCE_NAME_VALUE.CARAVAN:
      return mapToCommerceCaravan(data);
    case INSURANCE_NAME_VALUE.CHILD:
      return mapToCommerceChild(data, type);
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return mapToCommerceChildHealth(data, type);
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
      return mapToCommerceCriticalIllness(data);
    case INSURANCE_NAME_VALUE.DEATH:
      return mapToCommerceDeath(data);
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return mapToCommerceDisability(data);
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return mapToCommerceElectricScooter(data);
    case INSURANCE_NAME_VALUE.HEALTH:
      return mapToCommerceHealth(data);
    case INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING:
      return mapToCommerceHealthWithoutSigning(data);
    case INSURANCE_NAME_VALUE.HOUSE:
      return mapToCommerceHouse(data);
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return mapToCommerceHouseContents(data);
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return mapToCommerceHuseierneHouseContents(data);
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
      return mapToCommercePregnantAndNewborn(data);
    case INSURANCE_NAME_VALUE.MOPED:
      return mapToCommerceMoped(data);
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return mapToCommerceMotorcycle(data);
    case INSURANCE_NAME_VALUE.RENTAL:
      return mapToCommerceRental(data);
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return mapToCommerceSopSicknessLeave(data);
    case INSURANCE_NAME_VALUE.TRACTOR:
      return mapToCommerceTractor(data);
    case INSURANCE_NAME_VALUE.TRAILER:
      return mapToCommerceTrailer(data);
    case INSURANCE_NAME_VALUE.TRAVEL:
      return mapToCommerceTravel(data);
    case INSURANCE_NAME_VALUE.VALUABLES:
      return mapToCommerceValuables(data);
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return mapToCommerceVeteranAuto(data);
    default:
      return undefined;
  }
}
